import { Box, Grid, useMediaQuery, useTheme, Typography } from "@mui/material";
import Loader from "../components/Loader";
import React, { useState, useEffect } from "react";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import dustbin from "../../images/dustbin.png";
import UpdateLedgerDate from "./UpdateLedgerDate";
import BorderColorIcon from "@mui/icons-material/BorderColor";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#C1DECB",
    color: "#182648",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function LedgerDetailsTable({
  state,
  handleEdit,
  handleDelete,
  handleHistory,
}) {
  const { type } = useSelector((state) => state.ledger);
  console.log("type", type);
  const { detail } = useSelector((state) => state.ledgerDetail);
  const companyCode = localStorage.getItem("companyCode");
  const ledger = useSelector((state) => state.ledger.selected);
  const [open, setOpen] = useState(false);
  const [selectedBill, setSelectedBill] = useState(null);

  const ledgerDateHandler = (bill) => {
    console.log("new");
    setSelectedBill(bill);
    setOpen((prev) => !prev);
  };

  const showFilters = () => {
    if (state.filterDate !== "") {
      return detail.filter(
        (item) =>
          moment.unix(item.date / 1000).format("YYYY-MM-DD") ===
          state.filterDate
      );
    }
    return detail;
  };

  return (
    <TableContainer
      component={Paper}
      sx={{ position: "relative", top: { md: "150px", xs: "250px" } }}
    >
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>#</StyledTableCell>
            <StyledTableCell align="center">Date</StyledTableCell>
            <StyledTableCell align="center">Details</StyledTableCell>
            <StyledTableCell align="right">Total Amount</StyledTableCell>
            <StyledTableCell align="right">Deposited Amount</StyledTableCell>
            <StyledTableCell align="right">Remaining</StyledTableCell>
            <StyledTableCell align="right">Balance</StyledTableCell>
            <StyledTableCell align="center">Action</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {!state.loading &&
            showFilters().map((row, index) => (
              <StyledTableRow key={index + 1}>
                <StyledTableCell component="th" scope="row">
                  {index + 1}
                </StyledTableCell>
                {/* <StyledTableCell align="center"  onClick={()=> ledgerDateHandler(row)}> */}
                <StyledTableCell align="center">
                  {row.date ?(typeof row?.date === "string"
                    ? moment(row.date, "YYYY-MM-DD").format("DD-MM-YYYY")
                    :  moment.unix(row?.date?.toString()?.length === 10 ? row.date : row.date / 1000).format("DD-MM-YYYY")) : "N/A"}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.detail}
                  {row.invoiceNumber ? ` Invoice No ${row.invoiceNumber}` : ""}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.totalAmount}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.depositedAmount}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.remainingAmount}
                </StyledTableCell>
                {/* <StyledTableCell align="right">{row.balance > 0 ? row.balance : 0}</StyledTableCell> */}
                <StyledTableCell align="right">
                  {row.balance ? row.balance : 0}
                </StyledTableCell>
                <StyledTableCell align="center">
                  <BorderColorIcon
                    sx={{ color: "#4eaf51" }}
                    onClick={() => handleEdit(row)}
                  />
                  <i
                    className="far fa-calendar-alt curPoint leftTen"
                    onClick={() => handleHistory(row)}
                  />
                  {companyCode !== "4890" && (
                    <img
                      className="dustbin leftTen h20"
                      src={dustbin}
                      alt="Delete"
                      onClick={() => handleDelete(row)}
                    />
                  )}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          {open && selectedBill && (
            <UpdateLedgerDate
              bill={selectedBill}
              onClose={() => setOpen(false)}
              onSuccess={() => {
                // Optional: handle success action
              }}
            />
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

// const  LedgerDetailsTable = (state)=> {
//     const { type } = useSelector((state) => state.ledger);
//     const { detail } = useSelector((state) => state.ledgerDetail);

//     const ledger = useSelector((state) => state.ledger.selected);

//    console.log('satae', state)

//   const theme = useTheme();
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
//   const showFilters = () => {
//     // if (ledger && type) {
//     if (state.state.filterDate != "") {
//       let filtered = detail.filter(
//         (item) =>
//           moment.unix(item.date / 1000).format("YYYY-MM-DD") == state.filterDate
//       );
//       console.log('filtered', filtered)
//       return filtered;
//     } else {
//       console.log('details', detail)
//       return detail;
//     }
//     // } else {
//     //   return [];
//     // }
//   };

// return(
//     <BodyContainer
//     sx={{ position: "relative", top: { md: "0px", xs: "40px" } }}
//   >
//     <Box className="rowSty">
//       <Grid container columns={24}>
//         <Grid item xs={1}>
//           <Typography sx={{ fontSize: { md: "16px", xs: "10px" } }}>
//             #
//           </Typography>
//         </Grid>
//         <Grid item xs={3}>
//           <Typography sx={{ fontSize: { md: "16px", xs: "10px" } }}>
//             Date
//           </Typography>
//         </Grid>
//         <Grid item xs={3}>
//           <Typography sx={{ fontSize: { md: "16px", xs: "10px" } }}>
//             Details
//           </Typography>
//         </Grid>
//         <Grid item xs={3}>
//           <Typography sx={{ fontSize: { md: "16px", xs: "10px" } }}>
//             Total Amount
//           </Typography>
//         </Grid>

//         <Grid item xs={3}>
//           <Typography sx={{ fontSize: { md: "16px", xs: "10px" } }}>
//             {type == "purchase" ? "Paid" : "Deposited"}
//           </Typography>
//         </Grid>
//         <Grid item xs={4}>
//           <Typography sx={{ fontSize: { md: "16px", xs: "10px" } }}>
//             Remaining
//           </Typography>
//         </Grid>
//         <Grid item xs={4}>
//           <Typography sx={{ fontSize: { md: "16px", xs: "10px" } }}>
//             Balance
//           </Typography>
//         </Grid>
//         <Grid item xs={3}>
//           <Typography sx={{ fontSize: { md: "16px", xs: "10px" } }}>
//             Actions
//           </Typography>
//         </Grid>
//       </Grid>
//     </Box>

//     {!state.state.loading &&
//       showFilters()?.map((ledgerItem, index) => {
//         return (
//           <Box
//           key={index}
//           className={
//             index % 2 == 0 ? "bgwhite nxtRowSty" : "bgopgray nxtRowSty"
//           }
//           sx={{
//             overflowX: isSmallScreen ? "auto" : "unset",
//             whiteSpace: isSmallScreen ? "nowrap" : "normal",
//           }}
//             >
// <Grid container columns={104} sx={{ minWidth: '550px', display: 'flex', flexWrap: 'nowrap' }}>
// <Grid item className="text-grays" xs={3}>
//               {index + 1}
//             </Grid>
//             <Grid item className="text-grays" xs={25} md={15}>
//               {moment.unix(ledgerItem.date / 1000).format("MM-DD-YYYY")}
//             </Grid>
//             <Grid item className=" text-grays" xs={18}>
//               {ledgerItem.detail}
//             </Grid>

//             <Grid item className=" text-grays" xs={13}>
//               <b>{ledgerItem.totalAmount || 0}</b>
//             </Grid>
//             <Grid item className=" text-grays" xs={13}>
//               <b> {ledgerItem.depositedAmount}</b>
//             </Grid>
//             <Grid item className=" text-grays" xs={13}>
//               <b> {ledgerItem.remainingAmount}</b>
//             </Grid>
//             <Grid item className=" text-grays" xs={15} >
//               <b>{ledgerItem.balance || 0}</b>
//             </Grid>
//             <Grid item className="text-grays" xs={12} md={1} sx={{ display: isSmallScreen ? '' : "flex",alignItems:isSmallScreen ? '' : "center"}}>
//             <i
//                 onClick={() => handleEdit(ledgerItem)}
//                 className=" fas fa-edit leftMinTen curPoint"
//               ></i>
//               <i

//                 className="far fa-calendar-alt curPoint leftTen"
//                 onClick={() => handleHistory(ledgerItem.srNum)}
//               />

//               <img
//               //  style={{ marginTop:"10px"}}
//                 className="dustbin leftTen h20"
//                 src={dustbin}
//                 alt="img"
//                 onClick={() => handleDelete(ledgerItem)}
//               />
//             </Grid>
//           </Grid>
//         </Box>

//         );
//       })}
//     {state.loading && <Loader loading={state.loading} />}
//   </BodyContainer>
// );
// }

// export default LedgerDetailsTable;
